import { decodePeriodValue, getPeriodButtonLabel } from '@components'

import { getFormatLocale } from '@billy/design-system/src/formatters/utils/getFormatLocale'
import { Text, View } from '@react-pdf/renderer'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { headerPdfStyles } from '@features/exports/utils/headerPdfStyles'

import { getCurrentLocale } from '../../../../../../utils'
import { useReportsPdfDocument } from '../../contexts/reportsPdfDocumentContext'

export const ReportsPdfHeader = () => {
  const { t } = useTranslation()
  const { appliedFilters, organizationName, title } = useReportsPdfDocument()

  const now = new Date()
  const currentLocale = getCurrentLocale()
  const formatLocale = getFormatLocale(currentLocale)

  const periodValue = useMemo(() => {
    if (appliedFilters?.period) {
      const decodedPeriod = decodePeriodValue(appliedFilters.period)
      return getPeriodButtonLabel(t, decodedPeriod)
    }

    return null
  }, [appliedFilters.period, t])

  const formattedDate = new Intl.DateTimeFormat(formatLocale, {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  }).format(now)

  const { container, metaText, metaWrapper, titleText, titleWrapper } = headerPdfStyles

  return (
    <View style={container} fixed={true}>
      <View style={titleWrapper}>
        <Text style={titleText}>{title.toUpperCase()}</Text>
      </View>

      <View style={metaWrapper}>
        <View>
          <Text style={metaText}>{organizationName}</Text>
          {periodValue && <Text style={metaText}>{periodValue}</Text>}
        </View>
        <Text style={metaText}>{`${t('date')}: ${formattedDate}`}</Text>
      </View>
    </View>
  )
}
